<template>
  <div>
    <v-layout justify-start wrap pa-2>
      <v-flex xs12 sm6 md3 lg2>
        <span
          style="color: #000000; font-family: nunitosansbold; font-size: 16px"
          >Attendance Report</span
        >
      </v-flex>
      <v-flex xs7 sm8 md6 lg7 pl-lg-5>
        <span
          style="color: #000000; font-family: nunitosansbold; font-size: 16px"
          >{{ month }}</span
        >
      </v-flex>
      <v-flex xs5 sm4 md2 lg2 offset-md1>
        <v-layout justify-end wrap>
          <v-flex xs11 sm8 md8 text-right>
            <span
              style="
                color: #606060;
                font-family: nunitosansregular;
                font-size: 12px;
              "
              >Download</span
            >
          </v-flex>
          <v-flex xs1 sm1 md1 text-right>
            <v-icon
              style="
                color: #606060;
                font-family: nunitosansregular;
                font-size: 16px;
              "
              >mdi-download-outline</v-icon
            >
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap py-5>
      <v-flex xs12>
        <v-card outlined>
          <v-card-text>
            <v-layout justify-start wrap>
              <v-flex xs12 v-for="(item, i) in attendance" :key="i">
                <v-layout justify-start wrap py-5>
                  <v-flex xs6>
                    <v-layout justify-start wrap>
                      <v-flex xs4 sm4 md4 lg4>
                        <span
                          style="
                            color: #000000;
                            font-family: nunitosansbold;
                            font-size: 16px;
                          "
                          >{{ item.month }} {{ item.year }}</span
                        >
                      </v-flex>
                      <v-flex xs8 sm8 md8 lg8 pl-lg-4>
                        <span
                          style="
                            color: #e63737;
                            font-family: nunitosanssemibold;
                          "
                          >{{ item.numberOfDaysAbsent }} Leave
                          <!-- <span v-if="item.numberOfDaysAbsent > 1">Leaves</span> -->
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6 text-right>
                    <v-layout justify-end wrap>
                      <v-flex xs2 sm2 md2 align-self-end text-right>
                        <span
                          style="
                            color: #000000;
                            font-family: nunitosanslight;
                            font-size: 35px;
                          "
                          >{{ item.numberOfDaysPresent }}</span
                        >
                      </v-flex>
                      <v-flex xs5 sm5 md2 text-center>
                        <span
                          style="
                            line-height: 0;
                            color: #797979;
                            font-family: nunitosansregular;
                            font-size: 12px;
                          "
                          >Days <br />
                          Present</span
                        >
                      </v-flex>
                      <v-flex xs1 sm1 md1 text-right pr-md-5>
                        <span
                          style="color: #000000; font-family: nunitosansbold"
                          >/</span
                        >
                      </v-flex>
                      <v-flex xs1 text-center>
                        <span
                          style="color: #000000; font-family: nunitosansbold"
                          >{{ item.numberOfDays }}</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- <v-flex xs12 :key="item.i"> -->
                <v-divider></v-divider>
                <!-- </v-flex> -->
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["storage"],
  data() {
    return {
      hover: false,
      page: 1,
      attendance: [],
      month: [],
      currentPage: 1,
      pages: 0,
      count: 36,
      totalData: 0,
      appLoading: false,
      ServerError: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/attendance/student/thisyear",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          student: this.storage,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.attendance = response.data.data;
          this.month = response.data.academicyear;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>